<template>
  <div class="d-flex align-center">
    <div style="color: gray">{{ secondsFormatted }}</div>
    <v-menu v-model="isOpen" :close-on-content-click="false" offset-x left nudge-left="20px" nudge-top="54px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" v-bind="attrs" @click="'';" icon>
          <v-icon> mdi-clock-outline </v-icon>
        </v-btn>
      </template>
      <v-card width="186px" elevation="0">
        <v-card-title style="font-size: 0.8rem" class="d-flex justify-center pt-2 pb-0">
          Atualização automática
        </v-card-title>
        <v-card-text class="pa-0 ma-0 d-flex justify-center align-center flex-column">
          <v-radio-group v-model="selectedType" dense row hide-details class="d-flex justify-center">
            <v-radio value="min" class="d-flex justify-center">
              <template #label>
                <span style="font-size: 0.8rem"> MIN </span>
              </template>
            </v-radio>
            <v-radio value="sec" class="d-flex justify-center">
              <template #label>
                <span style="font-size: 0.8rem"> SEG </span>
              </template>
            </v-radio>
          </v-radio-group>
          <div class="py-2">
            <input
              @keydown.enter="saveTimer"
              v-mask="'###'"
              v-model="timerValue"
              type="text"
              name=""
              class="timer-field"
            />
          </div>
        </v-card-text>
        <v-card-actions class="py-2 d-flex justify-center">
          <v-btn small color="error" @click="stopTimer">
            <v-icon x-small>mdi-square</v-icon>
          </v-btn>
          <v-btn small color="success" @click="saveTimer">
            <v-icon small>mdi-play</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { ExpandedManagementCardHandler } from '@/store/modules/expandedManagementCard';
import { ExpandedTranshipmentManagementCardHandler } from '@/store/modules/expandedTranshipmentManagementCard';
export default {
  data: () => ({
    selectedType: 'min',
    timerValue: 1,
    seconds: 0,
    isOpen: false,
    timerInterval: 0,
    savedTime: null
  }),

  computed: {
    secondsFormatted() {
      const minutes = Math.floor(this.seconds / 60);
      const seconds = this.seconds - 60 * minutes;
      const lessThanTenMinutes = minutes < 10;
      const lessThanTenSeconds = seconds < 10;
      return `${lessThanTenMinutes ? 0 : ''}${minutes}:${lessThanTenSeconds ? 0 : ''}${seconds}`;
    }
  },

  watch: {
    isOpen: {
      handler(isOpen) {
        if (isOpen) {
          return;
        } else {
          this.timerValue = this.savedTime;
        }
      }
    },

    seconds: {
      handler(seconds) {
        if (seconds === -1) {
          this.resetTimer();
        }
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.timerInterval);
  },

  methods: {
    saveTimer() {
      this.savedTime = this.timerValue;
      this.setSeconds();
      this.startTimer();
      this.isOpen = false;
    },

    onCancelSetTimer() {
      this.timerValue = this.savedTime;
    },

    setSeconds() {
      const secondsOrMinutes = Number(this.timerValue);
      if (this.selectedType === 'min') {
        this.seconds = secondsOrMinutes * 60;
      } else {
        this.seconds = secondsOrMinutes;
      }
    },

    startTimer() {
      clearInterval(this.timerInterval);
      this.timerInterval = setInterval(() => {
        this.seconds -= 1;
      }, 1000);
    },

    resetTimer() {
      const savedTime = Number(this.savedTime);
      const secondsByType = {
        min: savedTime * 60,
        sec: savedTime
      };
      this.seconds = secondsByType[this.selectedType];

      ExpandedManagementCardHandler.setShouldRefreshWhenTimerEnds(this, true);
      ExpandedTranshipmentManagementCardHandler.setShouldRefreshWhenTimerEnds(this, true);
    },

    stopTimer() {
      this.resetTimer();
      clearInterval(this.timerInterval);
      this.isOpen = false;
      console.log(this.timerInterval);
    }
  }
};
</script>

<style lang="scss" scoped>
.timer-field {
  border-style: solid;
  border-color: #e2e2e2;
  border-width: 1px;
  outline-width: 1px;
  outline-color: gray;
  padding-left: 10px;
  max-width: 150px;
}
</style>
